import { render, staticRenderFns } from "./UpsertResourceValidator.vue?vue&type=template&id=2664f26a&lang=pug&"
import script from "./UpsertResourceValidator.vue?vue&type=script&lang=js&"
export * from "./UpsertResourceValidator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports